/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 16
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/0x/Matcha%20Prod/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production';

export const ApiKey: Record<Environment, string> = {
  production: 'd97474224f9b20eed83b583fdb6949db'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '16',
    branch: 'main',
    source: 'web',
    versionId: 'd5c00461-182d-4675-a133-4c0cea25edec'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  initial_dclid?: any;
  initial_fbclid?: any;
  initial_gbraid?: any;
  initial_gclid?: any;
  initial_ko_click_id?: any;
  initial_msclkid?: any;
  initial_referrer?: any;
  initial_referring_domain?: any;
  initial_ttclid?: any;
  initial_twclid?: any;
  initial_utm_campaign?: any;
  initial_utm_content?: any;
  initial_utm_medium?: any;
  initial_utm_source?: any;
  initial_utm_term?: any;
  initial_wbraid?: any;
  referrer?: any;
  referring_domain?: any;
  wallet_addresses_used?: any;
}

export interface AddTpSlClickedProperties {
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface BatchLimitOrderCancelProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id: number;
}

export interface CategoryFilterSelectedProperties {
  filter_value: string;
}

export interface ChartExpandedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | expand, collapse |
   */
  ui_action: "expand" | "collapse";
}

export interface ChartIntervalChangedProperties {
  /**
   * Time interval (e.g. 1m, 5m, 1h, 7d)
   */
  chart_interval?: string;
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
}

export interface ChartTimeframeChangedProperties {
  /**
   * Time range (e.g. 1h, 24h, 7d, 30d, Max)
   */
  chart_timeframe?: string;
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
}

export interface ChartTimezoneChangedProperties {
  /**
   * Timezone used on chart (e.g. UTC, America/NewYork, etc.)
   */
  chart_timezone?: string;
}

export interface ChartTypeChangedProperties {
  /**
   * Display type (e.g. candle, line, etc)
   */
  chart_type?: string;
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface DiscoveryTableSearchInitiatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | popular, trending, wrapped, social, lsts, launchpads, currencies, stocks, commodities |
   */
  discovery_preset:
    | "popular"
    | "trending"
    | "wrapped"
    | "social"
    | "lsts"
    | "launchpads"
    | "currencies"
    | "stocks"
    | "commodities";
  had_network_filter: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  result_count: number;
  search_term: string;
}

export interface DynamicSlippageToggledProperties {
  /**
   * Position in UI
   */
  ui_location?: string;
  /**
   * Component state (e.g. opened, closed, on, off)
   */
  ui_state?: string;
}

export interface ExportTradesButtonClickedProperties {
  /**
   * public address of the user connecting the wallet
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  count: number;
}

export interface FeeInfoDropdownToggledProperties {
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * Component state (e.g. opened, closed, on, off)
   */
  ui_state?: string;
}

export interface FeedbackSubmittedProperties {
  /**
   * In the user feedback modal, the user has the option of providing their contact information. This property will capture the contact email or username. Reference the contact_type property to identify which platform the contact provided here belongs to.
   */
  contact_provided?: string;
  /**
   * The contact type can either be an email, farcaster, or x (twitter) username handle.
   */
  contact_type?: string;
  feedback_text: string;
}

export interface FeedbackToastClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | portfolio, swap |
   */
  surface: "portfolio" | "swap";
}

export interface FeedbackToastDismissedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id?: number;
  surface: string;
}

export interface FeedbackToastDisplayedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id?: number;
  surface: string;
}

export interface HomepageCategoryClickedProperties {
  category: string;
}

export interface HomepageNetworkFilterClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | number |
   */
  selected_chain_ids?: number[];
}

export interface HomepageSortChangedProperties {
  sort_column: string;
  sort_direction: string;
}

export interface HomepageTimeframeChangedProperties {
  category: string;
  timeframe_label: string;
}

export interface HomepageTokenClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface JacketClaimModalViewedProperties {
  /**
   * public address of the user connecting the wallet
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  address: string;
}

export interface JacketClaimSubmittedProperties {
  /**
   * public address of the user connecting the wallet
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  address: string;
}

export interface LearnMoreClickedProperties {
  /**
   * Component name
   */
  ui_component?: string;
}

export interface LimitOrderCancelledProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * The liquidity provider or protocol used to fill the limit order. Examples: '1inch', 'definitive'. Defaults to '1inch' when no other provider is specified.
   */
  limit_order_provider?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
}

export interface LimitOrderExpiryUpdatedProperties {
  /**
   * Fired when the user selects a limit order expiry type.
   */
  limit_order_expiry_type: string;
}

export interface LimitOrderPartialFillsToggledProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  component?: string;
  is_selected: boolean;
}

export interface LiquidityButtonClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface LiquidityScoreLearnMoreClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface LiquiditySourcesSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  liquidity_sources?: string[];
}

export interface MatchaAutoSettingUpdatedProperties {
  /**
   * Component state (e.g. opened, closed, on, off)
   */
  ui_state?: string;
}

export interface MaxApprovalToggledProperties {
  enabled: boolean;
}

export interface OrderTypeTabSelectedProperties {
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
}

export interface PaidFeedbackModalSubmittedProperties {
  wallet_address: string;
}

export interface PaidFeedbackModalViewedProperties {
  wallet_address: string;
}

export interface PortfolioDataRefreshedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  chain_count?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  portfolio_asset_count: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  portfolio_total_value_usd?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  refresh_interval_seconds: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | page_load, browser_refresh, user_initiated, auto_refresh |
   */
  refresh_trigger: "page_load" | "browser_refresh" | "user_initiated" | "auto_refresh";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  wallet_count: number;
}

export interface RecipientAddressUpdatedProperties {
  recipient_address?: string;
}

export interface RwaSwapInitiatedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id: number;
  rwa_token_address: string;
  rwa_token_side: string;
  rwa_token_symbol: string;
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  transaction_hash?: string;
}

export interface SankeyChartExpandedProperties {
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface SearchAbandonedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  "[Amplitude] Session Replay ID"?: string;
  /**
   * Where the search was originated. (e.g. - sell_token indicates the user initiated the search from the sell token selector in the transaction module).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_page, sell_token, buy_token, header |
   */
  search_type?: "home_page" | "sell_token" | "buy_token" | "header";
}

export interface SearchExecutedProperties {
  /**
   * User's search input
   */
  search_query?: string;
  /**
   * Number of results returned from the users search query.
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  search_results_count?: number;
  /**
   * Where the search was originated. (e.g. - sell_token indicates the user initiated the search from the sell token selector in the transaction module).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_page, sell_token, buy_token, header |
   */
  search_type?: "home_page" | "sell_token" | "buy_token" | "header";
}

export interface SearchFocusedProperties {
  /**
   * Where the search was originated. (e.g. - sell_token indicates the user initiated the search from the sell token selector in the transaction module).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_page, sell_token, buy_token, header |
   */
  search_type?: "home_page" | "sell_token" | "buy_token" | "header";
}

export interface SearchShowMoreClickedProperties {
  /**
   * Where the search was originated. (e.g. - sell_token indicates the user initiated the search from the sell token selector in the transaction module).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_page, sell_token, buy_token, header |
   */
  search_type?: "home_page" | "sell_token" | "buy_token" | "header";
}

export interface SearchTokenSelectedProperties {
  /**
   * Token address selected
   */
  search_selected_address?: string;
  search_selected_chain_name: string;
  search_selected_symbol: string;
  /**
   * Where the search was originated. (e.g. - sell_token indicates the user initiated the search from the sell token selector in the transaction module).
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | home_page, sell_token, buy_token, header |
   */
  search_type?: "home_page" | "sell_token" | "buy_token" | "header";
}

export interface SecurityAuditClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface SecurityAuditLearnMoreClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface SellAmountPresetSelectedProperties {
  /**
   * **Fired when the user clicks the sell token shortcut button.**
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | clear, 50%, max |
   */
  sell_amount_preset_type: "clear" | "50%" | "max";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
}

export interface SlippageSettingUpdatedProperties {
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | auto, manual |
   */
  swap_slippage_mode: "auto" | "manual";
  /**
   * User's slippage tolerance as percentage (0.5 = 0.5%)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  swap_slippage_percent: number;
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface SuggestedTokenSelectedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  chain_id: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  rank: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | owned_only, empty_side |
   */
  suggestion_mode: "owned_only" | "empty_side";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  token_symbol: string;
}

export interface SwapInitiatedProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Amount in token units
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  buy_token_amount: number;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  buy_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  buy_token_amount_usd?: number;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * The liquidity provider or protocol used to fill the limit order. Examples: '1inch', 'definitive'. Defaults to '1inch' when no other provider is specified.
   */
  limit_order_provider?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  matcha_referrer?: string;
  recipient_address?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Amount in token units
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount?: number;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  sell_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount_usd?: number;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  /**
   * Market Order Transaction Type (standard or gasless)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | standard, gasless |
   */
  swap_execution_type?: "standard" | "gasless";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface ThemeToggledProperties {
  theme: string;
}

export interface TokenAddressCopiedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
}

export interface TokenApproveInitiatedProperties {
  is_gasless_approval: boolean;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Amount in token units
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount?: number;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount_usd?: number;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
}

export interface TokenApprovedProperties {
  is_gasless_approval: boolean;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount: number;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount_usd?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id: number;
  sell_token_chain_name: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol: string;
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
}

export interface TokenDescriptionExpandedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface TokenGroupToggledProperties {
  token_symbol?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | expand, collapse |
   */
  ui_action: "expand" | "collapse";
}

export interface TokenOfficialLinkClickedProperties {
  link_type: string;
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
}

export interface TokenPairFlippedProperties {
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
}

export interface TokenShareClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface TokenSwitchClickedProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export interface TradeRefreshClickedProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  /**
   * Place where the button was clicked, it can be either the **main button, trade_module** button, or the **connect another wallet** button
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | primary_button, other_wallet_option, trade_module, trade_history_page, keyboard, refresh_button |
   */
  source:
    | "primary_button"
    | "other_wallet_option"
    | "trade_module"
    | "trade_history_page"
    | "keyboard"
    | "refresh_button";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, cross-chain |
   */
  trade_type: "market" | "cross-chain";
}

export interface TradeSettingsOpenedProperties {
  /**
   * Market Order Transaction Type (standard or gasless)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | standard, gasless |
   */
  swap_execution_type?: "standard" | "gasless";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
}

export interface TransactionCompletedProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  buy_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  buy_token_amount_usd?: number;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  matcha_referrer?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  sell_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount_usd?: number;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  /**
   * Market Order Transaction Type (standard or gasless)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | standard, gasless |
   */
  swap_execution_type?: "standard" | "gasless";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | jupiter, zeroex |
   */
  swap_provider?: "jupiter" | "zeroex";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  swap_slippage_bps?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | auto, manual |
   */
  swap_slippage_mode?: "auto" | "manual";
  /**
   * On chain Transaction hash of the swap.
   */
  swap_tx_hash: string;
  /**
   * Quote identifier from 0xAPI
   */
  swap_zid?: string;
}

export interface TransactionFailedProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | user_rejected, rpc_error, relayer_rejected, bridge_endpoint_error, submission_error, on_chain_revert, origin_tx_reverted, bridge_failed, bridge_unknown, solana_program_error, gasless_failed, relayer_unavailable, wallet_not_ready, cancelled_by_user, replaced, not_observed, orderbook_unavailable, orderbook_rejected, network_error, insufficient_balance |
   */
  failure_reason:
    | "user_rejected"
    | "rpc_error"
    | "relayer_rejected"
    | "bridge_endpoint_error"
    | "submission_error"
    | "on_chain_revert"
    | "origin_tx_reverted"
    | "bridge_failed"
    | "bridge_unknown"
    | "solana_program_error"
    | "gasless_failed"
    | "relayer_unavailable"
    | "wallet_not_ready"
    | "cancelled_by_user"
    | "replaced"
    | "not_observed"
    | "orderbook_unavailable"
    | "orderbook_rejected"
    | "network_error"
    | "insufficient_balance";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | submission, inclusion, pre_submission |
   */
  failure_stage: "submission" | "inclusion" | "pre_submission";
  /**
   * The liquidity provider or protocol used to fill the limit order. Examples: '1inch', 'definitive'. Defaults to '1inch' when no other provider is specified.
   */
  limit_order_provider?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  matcha_referrer?: string;
  recipient_address?: string;
  /**
   * Relayer rejection detail behind a `relayer_rejected` gasless-submit failure. The 0x API error code from the relayer response body.
   */
  relayer_reason?: string;
  revert_reason?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  submission_reason?: string;
  /**
   * Market Order Transaction Type (standard or gasless)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | standard, gasless |
   */
  swap_execution_type?: "standard" | "gasless";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | jupiter, zeroex |
   */
  swap_provider?: "jupiter" | "zeroex";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  swap_slippage_bps?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | auto, manual |
   */
  swap_slippage_mode?: "auto" | "manual";
  /**
   * On chain Transaction hash of the swap.
   */
  swap_tx_hash?: string;
  /**
   * Quote identifier from 0xAPI
   */
  swap_zid?: string;
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface TransactionStepBackProperties {
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface TransactionSubmittedProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Amount in token units
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  buy_token_amount: number;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  buy_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  buy_token_amount_usd?: number;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
  is_smart_wallet?: boolean;
  /**
   * The liquidity provider or protocol used to fill the limit order. Examples: '1inch', 'definitive'. Defaults to '1inch' when no other provider is specified.
   */
  limit_order_provider?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  matcha_referrer?: string;
  recipient_address?: string;
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Amount in token units
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount?: number;
  /**
   * USD bucket for cohort analysis.
   *
   *
   * USD bucket values: 0-10, 10-100, 100-1000, 1000-10000, 10000-100000, 100000-1000000, 1000000+
   */
  sell_token_amount_bucket?: string;
  /**
   * USD value at time of event
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  sell_token_amount_usd?: number;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
  /**
   * Market Order Transaction Type (standard or gasless)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | standard, gasless |
   */
  swap_execution_type?: "standard" | "gasless";
  /**
   * Type of swap (market, limit, cross_chain)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | market, limit, cross_chain, wrap, stop_loss, take_profit |
   */
  swap_order_type: "market" | "limit" | "cross_chain" | "wrap" | "stop_loss" | "take_profit";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | jupiter, zeroex |
   */
  swap_provider?: "jupiter" | "zeroex";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  swap_slippage_bps?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | auto, manual |
   */
  swap_slippage_mode?: "auto" | "manual";
  /**
   * On chain Transaction hash of the swap.
   */
  swap_tx_hash: string;
  /**
   * Quote identifier from 0xAPI
   */
  swap_zid?: string;
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface WalletConnectClickedProperties {
  /**
   * Place where the button was clicked, it can be either the **main button, trade_module** button, or the **connect another wallet** button
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | primary_button, other_wallet_option, trade_module, trade_history_page, keyboard, refresh_button |
   */
  source:
    | "primary_button"
    | "other_wallet_option"
    | "trade_module"
    | "trade_history_page"
    | "keyboard"
    | "refresh_button";
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface WalletConnectionUpdatedProperties {
  connection_status: string;
  evm_wallet_address?: string;
  evm_wallet_provider?: string;
  solana_wallet_address?: string;
  solana_wallet_provider?: string;
}

export interface WalletDisconnectClickedProperties {
  /**
   * Place where the button was clicked, it can be either the **main button, trade_module** button, or the **connect another wallet** button
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | primary_button, other_wallet_option, trade_module, trade_history_page, keyboard, refresh_button |
   */
  source:
    | "primary_button"
    | "other_wallet_option"
    | "trade_module"
    | "trade_history_page"
    | "keyboard"
    | "refresh_button";
  /**
   * Position in UI
   */
  ui_location?: string;
}

export interface ZoraProfileCoinsClickedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  creator_contract_address?: string;
}

export interface BuyTokenMetadataProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_address?: string;
  /**
   * Chain Id
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  buy_token_chain_id: number;
  /**
   * Human-readable chain name
   */
  buy_token_chain_name: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  buy_token_symbol?: string;
}

export interface SellTokenMetadataProperties {
  /**
   * Token contract address
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_address?: string;
  /**
   * Chain ID
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  sell_token_chain_id?: number;
  /**
   * Human-readable chain name.
   */
  sell_token_chain_name?: string;
  /**
   * Token ticker symbol
   *
   * | Rule | Value |
   * |---|---|
   * | Regex |  |
   */
  sell_token_symbol?: string;
}

export interface TokenMetadataProperties {
  token_address: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  token_chain_id?: number;
  token_chain_name: string;
  token_symbol?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AddTpSlClicked implements BaseEvent {
  event_type = 'add_tp_sl_clicked';

  constructor(
    public event_properties?: AddTpSlClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class BatchLimitOrderCancel implements BaseEvent {
  event_type = 'batch_limit_order_cancel';

  constructor(
    public event_properties: BatchLimitOrderCancelProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CategoryFilterSelected implements BaseEvent {
  event_type = 'category_filter_selected';

  constructor(
    public event_properties: CategoryFilterSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartExpanded implements BaseEvent {
  event_type = 'chart_expanded';

  constructor(
    public event_properties: ChartExpandedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartIntervalChanged implements BaseEvent {
  event_type = 'chart_interval_changed';

  constructor(
    public event_properties: ChartIntervalChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartTimeframeChanged implements BaseEvent {
  event_type = 'chart_timeframe_changed';

  constructor(
    public event_properties: ChartTimeframeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartTimezoneChanged implements BaseEvent {
  event_type = 'chart_timezone_changed';

  constructor(
    public event_properties?: ChartTimezoneChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChartTypeChanged implements BaseEvent {
  event_type = 'chart_type_changed';

  constructor(
    public event_properties: ChartTypeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatWithUsPageSubmitted implements BaseEvent {
  event_type = 'chat_with_us_page_submitted';
}

export class ChatWithUsPageViewed implements BaseEvent {
  event_type = 'chat_with_us_page_viewed';
}

export class DiscoveryTableSearchInitiated implements BaseEvent {
  event_type = 'discovery_table_search_initiated';

  constructor(
    public event_properties: DiscoveryTableSearchInitiatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DynamicSlippageToggled implements BaseEvent {
  event_type = 'dynamic_slippage_toggled';

  constructor(
    public event_properties?: DynamicSlippageToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExportTradesButtonClicked implements BaseEvent {
  event_type = 'export_trades_button_clicked';

  constructor(
    public event_properties: ExportTradesButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeeInfoDropdownToggled implements BaseEvent {
  event_type = 'fee_info_dropdown_toggled';

  constructor(
    public event_properties: FeeInfoDropdownToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackModalDismissed implements BaseEvent {
  event_type = 'feedback_modal_dismissed';
}

export class FeedbackModalDisplayed implements BaseEvent {
  event_type = 'feedback_modal_displayed';
}

export class FeedbackSubmitted implements BaseEvent {
  event_type = 'feedback_submitted';

  constructor(
    public event_properties: FeedbackSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackToastClicked implements BaseEvent {
  event_type = 'feedback_toast_clicked';

  constructor(
    public event_properties: FeedbackToastClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackToastDismissed implements BaseEvent {
  event_type = 'feedback_toast_dismissed';

  constructor(
    public event_properties: FeedbackToastDismissedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackToastDisplayed implements BaseEvent {
  event_type = 'feedback_toast_displayed';

  constructor(
    public event_properties: FeedbackToastDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FooterCrossChainClicked implements BaseEvent {
  event_type = 'footer_cross_chain_clicked';
}

export class FooterLimitClicked implements BaseEvent {
  event_type = 'footer_limit_clicked';
}

export class FooterSwapClicked implements BaseEvent {
  event_type = 'footer_swap_clicked';
}

export class HistoryClicked implements BaseEvent {
  event_type = 'history_clicked';
}

export class HistoryDetailViewed implements BaseEvent {
  event_type = 'history_detail_viewed';
}

export class HomepageCategoryClicked implements BaseEvent {
  event_type = 'homepage_category_clicked';

  constructor(
    public event_properties: HomepageCategoryClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomepageFilterApplied implements BaseEvent {
  event_type = 'homepage_filter_applied';
}

export class HomepageFilterReset implements BaseEvent {
  event_type = 'homepage_filter_reset';
}

export class HomepageNetworkFilterClicked implements BaseEvent {
  event_type = 'homepage_network_filter_clicked';

  constructor(
    public event_properties?: HomepageNetworkFilterClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomepageSortChanged implements BaseEvent {
  event_type = 'homepage_sort_changed';

  constructor(
    public event_properties: HomepageSortChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomepageTimeframeChanged implements BaseEvent {
  event_type = 'homepage_timeframe_changed';

  constructor(
    public event_properties: HomepageTimeframeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class HomepageTokenClicked implements BaseEvent {
  event_type = 'homepage_token_clicked';

  constructor(
    public event_properties: HomepageTokenClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JacketClaimModalViewed implements BaseEvent {
  event_type = 'jacket_claim_modal_viewed';

  constructor(
    public event_properties: JacketClaimModalViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class JacketClaimSubmitted implements BaseEvent {
  event_type = 'jacket_claim_submitted';

  constructor(
    public event_properties: JacketClaimSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LearnMoreClicked implements BaseEvent {
  event_type = 'learn_more_clicked';

  constructor(
    public event_properties?: LearnMoreClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LimitOrderCancelled implements BaseEvent {
  event_type = 'limit_order_cancelled';

  constructor(
    public event_properties: LimitOrderCancelledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LimitOrderExpiryUpdated implements BaseEvent {
  event_type = 'limit_order_expiry_updated';

  constructor(
    public event_properties: LimitOrderExpiryUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LimitOrderPartialFillsToggled implements BaseEvent {
  event_type = 'limit_order_partial_fills_toggled';

  constructor(
    public event_properties: LimitOrderPartialFillsToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LimitOrderSlider implements BaseEvent {
  event_type = 'limit_order_slider';
}

export class LiquidityButtonClicked implements BaseEvent {
  event_type = 'liquidity_button_clicked';

  constructor(
    public event_properties: LiquidityButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LiquidityScoreLearnMoreClicked implements BaseEvent {
  event_type = 'liquidity_score_learn_more_clicked';

  constructor(
    public event_properties: LiquidityScoreLearnMoreClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LiquiditySourcesSelected implements BaseEvent {
  event_type = 'liquidity_sources_selected';

  constructor(
    public event_properties?: LiquiditySourcesSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MatchaAutoSettingUpdated implements BaseEvent {
  event_type = 'matcha_auto_setting_updated';

  constructor(
    public event_properties?: MatchaAutoSettingUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaxApprovalToggled implements BaseEvent {
  event_type = 'max_approval_toggled';

  constructor(
    public event_properties: MaxApprovalToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MobileFeedbackModalSubmitted implements BaseEvent {
  event_type = 'mobile_feedback_modal_submitted';
}

export class MobileFeedbackModalViewed implements BaseEvent {
  event_type = 'mobile_feedback_modal_viewed';
}

export class NavDiscoverClicked implements BaseEvent {
  event_type = 'nav_discover_clicked';
}

export class NavHistoryClicked implements BaseEvent {
  event_type = 'nav_history_clicked';
}

export class NavTokensClicked implements BaseEvent {
  event_type = 'nav_tokens_clicked';
}

export class NavTradeClicked implements BaseEvent {
  event_type = 'nav_trade_clicked';
}

export class OrderTypeTabSelected implements BaseEvent {
  event_type = 'order_type_tab_selected';

  constructor(
    public event_properties: OrderTypeTabSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaidFeedbackModalSubmitted implements BaseEvent {
  event_type = 'paid_feedback_modal_submitted';

  constructor(
    public event_properties: PaidFeedbackModalSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PaidFeedbackModalViewed implements BaseEvent {
  event_type = 'paid_feedback_modal_viewed';

  constructor(
    public event_properties: PaidFeedbackModalViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PortfolioDataRefreshed implements BaseEvent {
  event_type = 'portfolio_data_refreshed';

  constructor(
    public event_properties: PortfolioDataRefreshedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ReceiveWalletSelectorClicked implements BaseEvent {
  event_type = 'receive_wallet_selector_clicked';
}

export class RecipientAddressUpdated implements BaseEvent {
  event_type = 'recipient_address_updated';

  constructor(
    public event_properties?: RecipientAddressUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class RwaSwapInitiated implements BaseEvent {
  event_type = 'rwa_swap_initiated';

  constructor(
    public event_properties: RwaSwapInitiatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SankeyChartExpanded implements BaseEvent {
  event_type = 'sankey_chart_expanded';

  constructor(
    public event_properties?: SankeyChartExpandedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchAbandoned implements BaseEvent {
  event_type = 'search_abandoned';

  constructor(
    public event_properties?: SearchAbandonedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchExecuted implements BaseEvent {
  event_type = 'search_executed';

  constructor(
    public event_properties?: SearchExecutedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchFocused implements BaseEvent {
  event_type = 'search_focused';

  constructor(
    public event_properties?: SearchFocusedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchShowMoreClicked implements BaseEvent {
  event_type = 'search_show_more_clicked';

  constructor(
    public event_properties?: SearchShowMoreClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchTokenSelected implements BaseEvent {
  event_type = 'search_token_selected';

  constructor(
    public event_properties: SearchTokenSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SecurityAuditClicked implements BaseEvent {
  event_type = 'security_audit_clicked';

  constructor(
    public event_properties: SecurityAuditClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SecurityAuditLearnMoreClicked implements BaseEvent {
  event_type = 'security_audit_learn_more_clicked';

  constructor(
    public event_properties: SecurityAuditLearnMoreClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SellAmountPresetSelected implements BaseEvent {
  event_type = 'sell_amount_preset_selected';

  constructor(
    public event_properties: SellAmountPresetSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SlippageSettingUpdated implements BaseEvent {
  event_type = 'slippage_setting_updated';

  constructor(
    public event_properties: SlippageSettingUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SuggestedTokenSelected implements BaseEvent {
  event_type = 'suggested_token_selected';

  constructor(
    public event_properties: SuggestedTokenSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SwapInitiated implements BaseEvent {
  event_type = 'swap_initiated';

  constructor(
    public event_properties: SwapInitiatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ThemeToggled implements BaseEvent {
  event_type = 'theme_toggled';

  constructor(
    public event_properties: ThemeToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenAddressCopied implements BaseEvent {
  event_type = 'token_address_copied';

  constructor(
    public event_properties: TokenAddressCopiedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenApproveInitiated implements BaseEvent {
  event_type = 'token_approve_initiated';

  constructor(
    public event_properties: TokenApproveInitiatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenApproved implements BaseEvent {
  event_type = 'token_approved';

  constructor(
    public event_properties: TokenApprovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenDescriptionExpanded implements BaseEvent {
  event_type = 'token_description_expanded';

  constructor(
    public event_properties: TokenDescriptionExpandedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenGroupToggled implements BaseEvent {
  event_type = 'token_group_toggled';

  constructor(
    public event_properties: TokenGroupToggledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenOfficialLinkClicked implements BaseEvent {
  event_type = 'token_official_link_clicked';

  constructor(
    public event_properties: TokenOfficialLinkClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenPairFlipped implements BaseEvent {
  event_type = 'token_pair_flipped';

  constructor(
    public event_properties?: TokenPairFlippedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenShareClicked implements BaseEvent {
  event_type = 'token_share_clicked';

  constructor(
    public event_properties: TokenShareClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TokenSwitchClicked implements BaseEvent {
  event_type = 'token_switch_clicked';

  constructor(
    public event_properties: TokenSwitchClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TradeRefreshClicked implements BaseEvent {
  event_type = 'trade_refresh_clicked';

  constructor(
    public event_properties: TradeRefreshClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TradeSettingsOpened implements BaseEvent {
  event_type = 'trade_settings_opened';

  constructor(
    public event_properties: TradeSettingsOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TradingCtaClicked implements BaseEvent {
  event_type = 'trading_cta_clicked';
}

export class TransactionCompleted implements BaseEvent {
  event_type = 'transaction_completed';

  constructor(
    public event_properties: TransactionCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TransactionDetailsViewed implements BaseEvent {
  event_type = 'transaction_details_viewed';
}

export class TransactionFailed implements BaseEvent {
  event_type = 'transaction_failed';

  constructor(
    public event_properties: TransactionFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TransactionStepBack implements BaseEvent {
  event_type = 'transaction_step_back';

  constructor(
    public event_properties?: TransactionStepBackProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TransactionSubmitted implements BaseEvent {
  event_type = 'transaction_submitted';

  constructor(
    public event_properties: TransactionSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletConnectClicked implements BaseEvent {
  event_type = 'wallet_connect_clicked';

  constructor(
    public event_properties: WalletConnectClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletConnectionUpdated implements BaseEvent {
  event_type = 'wallet_connection_updated';

  constructor(
    public event_properties: WalletConnectionUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WalletDisconnectClicked implements BaseEvent {
  event_type = 'wallet_disconnect_clicked';

  constructor(
    public event_properties: WalletDisconnectClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ZoraProfileCoinsClicked implements BaseEvent {
  event_type = 'zora_profile_coins_clicked';

  constructor(
    public event_properties?: ZoraProfileCoinsClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * add_tp_sl_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/add_tp_sl_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. ui_location)
   * @param options Amplitude event options.
   */
  addTpSlClicked(
    properties?: AddTpSlClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AddTpSlClicked(properties), options);
  }

  /**
   * batch_limit_order_cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/batch_limit_order_cancel)
   *
   * User cancels multiple limit orders at once.
   *
   * Owner: Deepanjal Gupta
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  batchLimitOrderCancel(
    properties: BatchLimitOrderCancelProperties,
    options?: EventOptions,
  ) {
    return this.track(new BatchLimitOrderCancel(properties), options);
  }

  /**
   * category_filter_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/category_filter_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. filter_value)
   * @param options Amplitude event options.
   */
  categoryFilterSelected(
    properties: CategoryFilterSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CategoryFilterSelected(properties), options);
  }

  /**
   * chart_expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chart_expanded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. ui_action)
   * @param options Amplitude event options.
   */
  chartExpanded(
    properties: ChartExpandedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartExpanded(properties), options);
  }

  /**
   * chart_interval_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chart_interval_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chart_interval)
   * @param options Amplitude event options.
   */
  chartIntervalChanged(
    properties: ChartIntervalChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartIntervalChanged(properties), options);
  }

  /**
   * chart_timeframe_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chart_timeframe_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chart_timeframe)
   * @param options Amplitude event options.
   */
  chartTimeframeChanged(
    properties: ChartTimeframeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartTimeframeChanged(properties), options);
  }

  /**
   * chart_timezone_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chart_timezone_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chart_timezone)
   * @param options Amplitude event options.
   */
  chartTimezoneChanged(
    properties?: ChartTimezoneChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartTimezoneChanged(properties), options);
  }

  /**
   * chart_type_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chart_type_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chart_type)
   * @param options Amplitude event options.
   */
  chartTypeChanged(
    properties: ChartTypeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChartTypeChanged(properties), options);
  }

  /**
   * chat_with_us_page_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chat_with_us_page_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  chatWithUsPageSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new ChatWithUsPageSubmitted(), options);
  }

  /**
   * chat_with_us_page_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/chat_with_us_page_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  chatWithUsPageViewed(
    options?: EventOptions,
  ) {
    return this.track(new ChatWithUsPageViewed(), options);
  }

  /**
   * discovery_table_search_initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/discovery_table_search_initiated)
   *
   * Fired once per completed Discover table category search after the 300 ms debounce when a non-empty query completes, including zero-result searches. Skipped while fetching to avoid double-counting stale responses.
   *
   * @param properties The event's properties (e.g. discovery_preset)
   * @param options Amplitude event options.
   */
  discoveryTableSearchInitiated(
    properties: DiscoveryTableSearchInitiatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DiscoveryTableSearchInitiated(properties), options);
  }

  /**
   * dynamic_slippage_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/dynamic_slippage_toggled)
   *
   * Fired when the user toggles dynamic slippage (Solana only). Jupiter-powered auto-slippage for volatile pairs.
   *
   * @param properties The event's properties (e.g. ui_location)
   * @param options Amplitude event options.
   */
  dynamicSlippageToggled(
    properties?: DynamicSlippageToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new DynamicSlippageToggled(properties), options);
  }

  /**
   * export_trades_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/export_trades_button_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. address)
   * @param options Amplitude event options.
   */
  exportTradesButtonClicked(
    properties: ExportTradesButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportTradesButtonClicked(properties), options);
  }

  /**
   * fee_info_dropdown_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/fee_info_dropdown_toggled)
   *
   * User expands/collapses fee breakdown in trade module.
   *
   * @param properties The event's properties (e.g. swap_order_type)
   * @param options Amplitude event options.
   */
  feeInfoDropdownToggled(
    properties: FeeInfoDropdownToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeeInfoDropdownToggled(properties), options);
  }

  /**
   * feedback_modal_dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_modal_dismissed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  feedbackModalDismissed(
    options?: EventOptions,
  ) {
    return this.track(new FeedbackModalDismissed(), options);
  }

  /**
   * feedback_modal_displayed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_modal_displayed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  feedbackModalDisplayed(
    options?: EventOptions,
  ) {
    return this.track(new FeedbackModalDisplayed(), options);
  }

  /**
   * feedback_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. contact_provided)
   * @param options Amplitude event options.
   */
  feedbackSubmitted(
    properties: FeedbackSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackSubmitted(properties), options);
  }

  /**
   * feedback_toast_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_toast_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  feedbackToastClicked(
    properties: FeedbackToastClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackToastClicked(properties), options);
  }

  /**
   * feedback_toast_dismissed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_toast_dismissed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  feedbackToastDismissed(
    properties: FeedbackToastDismissedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackToastDismissed(properties), options);
  }

  /**
   * feedback_toast_displayed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/feedback_toast_displayed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  feedbackToastDisplayed(
    properties: FeedbackToastDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackToastDisplayed(properties), options);
  }

  /**
   * footer_cross_chain_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/footer_cross_chain_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  footerCrossChainClicked(
    options?: EventOptions,
  ) {
    return this.track(new FooterCrossChainClicked(), options);
  }

  /**
   * footer_limit_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/footer_limit_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  footerLimitClicked(
    options?: EventOptions,
  ) {
    return this.track(new FooterLimitClicked(), options);
  }

  /**
   * footer_swap_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/footer_swap_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  footerSwapClicked(
    options?: EventOptions,
  ) {
    return this.track(new FooterSwapClicked(), options);
  }

  /**
   * history_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/history_clicked)
   *
   * Owner: Deepanjal Gupta
   *
   * @param options Amplitude event options.
   */
  historyClicked(
    options?: EventOptions,
  ) {
    return this.track(new HistoryClicked(), options);
  }

  /**
   * history_detail_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/history_detail_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  historyDetailViewed(
    options?: EventOptions,
  ) {
    return this.track(new HistoryDetailViewed(), options);
  }

  /**
   * homepage_category_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_category_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  homepageCategoryClicked(
    properties: HomepageCategoryClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageCategoryClicked(properties), options);
  }

  /**
   * homepage_filter_applied
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_filter_applied)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  homepageFilterApplied(
    options?: EventOptions,
  ) {
    return this.track(new HomepageFilterApplied(), options);
  }

  /**
   * homepage_filter_reset
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_filter_reset)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  homepageFilterReset(
    options?: EventOptions,
  ) {
    return this.track(new HomepageFilterReset(), options);
  }

  /**
   * homepage_network_filter_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_network_filter_clicked)
   *
   * Fired when a user modified the network filter for the discovery table on the homepage.
   *
   * @param properties The event's properties (e.g. selected_chain_ids)
   * @param options Amplitude event options.
   */
  homepageNetworkFilterClicked(
    properties?: HomepageNetworkFilterClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageNetworkFilterClicked(properties), options);
  }

  /**
   * homepage_sort_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_sort_changed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. sort_column)
   * @param options Amplitude event options.
   */
  homepageSortChanged(
    properties: HomepageSortChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageSortChanged(properties), options);
  }

  /**
   * homepage_timeframe_changed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_timeframe_changed)
   *
   * Fired when a user selects a timeframe filter which appears under certain categories.
   *
   * @param properties The event's properties (e.g. category)
   * @param options Amplitude event options.
   */
  homepageTimeframeChanged(
    properties: HomepageTimeframeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageTimeframeChanged(properties), options);
  }

  /**
   * homepage_token_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/homepage_token_clicked)
   *
   * Fired when a user selects a token from the Discovery table on the homepage.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  homepageTokenClicked(
    properties: HomepageTokenClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new HomepageTokenClicked(properties), options);
  }

  /**
   * jacket_claim_modal_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/jacket_claim_modal_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. address)
   * @param options Amplitude event options.
   */
  jacketClaimModalViewed(
    properties: JacketClaimModalViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new JacketClaimModalViewed(properties), options);
  }

  /**
   * jacket_claim_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/jacket_claim_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. address)
   * @param options Amplitude event options.
   */
  jacketClaimSubmitted(
    properties: JacketClaimSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new JacketClaimSubmitted(properties), options);
  }

  /**
   * learn_more_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/learn_more_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. ui_component)
   * @param options Amplitude event options.
   */
  learnMoreClicked(
    properties?: LearnMoreClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LearnMoreClicked(properties), options);
  }

  /**
   * limit_order_cancelled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/limit_order_cancelled)
   *
   * Fired after a limit order has been successfully cancelled by the user.
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  limitOrderCancelled(
    properties: LimitOrderCancelledProperties,
    options?: EventOptions,
  ) {
    return this.track(new LimitOrderCancelled(properties), options);
  }

  /**
   * limit_order_expiry_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/limit_order_expiry_updated)
   *
   * Fired when the user changes the expiration date for a limit order.
   *
   * @param properties The event's properties (e.g. limit_order_expiry_type)
   * @param options Amplitude event options.
   */
  limitOrderExpiryUpdated(
    properties: LimitOrderExpiryUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LimitOrderExpiryUpdated(properties), options);
  }

  /**
   * limit_order_partial_fills_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/limit_order_partial_fills_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. component)
   * @param options Amplitude event options.
   */
  limitOrderPartialFillsToggled(
    properties: LimitOrderPartialFillsToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new LimitOrderPartialFillsToggled(properties), options);
  }

  /**
   * limit_order_slider
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/limit_order_slider)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  limitOrderSlider(
    options?: EventOptions,
  ) {
    return this.track(new LimitOrderSlider(), options);
  }

  /**
   * liquidity_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/liquidity_button_clicked)
   *
   * Event is fired when the user clicks on the liquidity button in the token page header.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  liquidityButtonClicked(
    properties: LiquidityButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LiquidityButtonClicked(properties), options);
  }

  /**
   * liquidity_score_learn_more_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/liquidity_score_learn_more_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  liquidityScoreLearnMoreClicked(
    properties: LiquidityScoreLearnMoreClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LiquidityScoreLearnMoreClicked(properties), options);
  }

  /**
   * liquidity_sources_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/liquidity_sources_selected)
   *
   * Using global market settings, the user selects or deselects liquidity sources for their route.
   *
   * @param properties The event's properties (e.g. liquidity_sources)
   * @param options Amplitude event options.
   */
  liquiditySourcesSelected(
    properties?: LiquiditySourcesSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LiquiditySourcesSelected(properties), options);
  }

  /**
   * matcha_auto_setting_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/matcha_auto_setting_updated)
   *
   * User toggles between standard and gasless (Matcha Auto) execution. Key for gasless adoption metrics.
   *
   * @param properties The event's properties (e.g. ui_state)
   * @param options Amplitude event options.
   */
  matchaAutoSettingUpdated(
    properties?: MatchaAutoSettingUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MatchaAutoSettingUpdated(properties), options);
  }

  /**
   * max_approval_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/max_approval_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. enabled)
   * @param options Amplitude event options.
   */
  maxApprovalToggled(
    properties: MaxApprovalToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaxApprovalToggled(properties), options);
  }

  /**
   * mobile_feedback_modal_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/mobile_feedback_modal_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  mobileFeedbackModalSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new MobileFeedbackModalSubmitted(), options);
  }

  /**
   * mobile_feedback_modal_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/mobile_feedback_modal_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  mobileFeedbackModalViewed(
    options?: EventOptions,
  ) {
    return this.track(new MobileFeedbackModalViewed(), options);
  }

  /**
   * nav_discover_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/nav_discover_clicked)
   *
   * Fired when the user clicks on the "Discover" navigation link
   *
   * @param options Amplitude event options.
   */
  navDiscoverClicked(
    options?: EventOptions,
  ) {
    return this.track(new NavDiscoverClicked(), options);
  }

  /**
   * nav_history_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/nav_history_clicked)
   *
   * Fired when the user clicks on the "History" navigation link
   *
   * @param options Amplitude event options.
   */
  navHistoryClicked(
    options?: EventOptions,
  ) {
    return this.track(new NavHistoryClicked(), options);
  }

  /**
   * nav_tokens_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/nav_tokens_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  navTokensClicked(
    options?: EventOptions,
  ) {
    return this.track(new NavTokensClicked(), options);
  }

  /**
   * nav_trade_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/nav_trade_clicked)
   *
   * Fired when the user clicks on the "Trade" navigation link
   *
   * @param options Amplitude event options.
   */
  navTradeClicked(
    options?: EventOptions,
  ) {
    return this.track(new NavTradeClicked(), options);
  }

  /**
   * order_type_tab_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/order_type_tab_selected)
   *
   * Fired when a user switches between Market/Limit/Cross-Chain tabs in the trade module.
   *
   * @param properties The event's properties (e.g. swap_order_type)
   * @param options Amplitude event options.
   */
  orderTypeTabSelected(
    properties: OrderTypeTabSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new OrderTypeTabSelected(properties), options);
  }

  /**
   * paid_feedback_modal_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/paid_feedback_modal_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wallet_address)
   * @param options Amplitude event options.
   */
  paidFeedbackModalSubmitted(
    properties: PaidFeedbackModalSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaidFeedbackModalSubmitted(properties), options);
  }

  /**
   * paid_feedback_modal_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/paid_feedback_modal_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. wallet_address)
   * @param options Amplitude event options.
   */
  paidFeedbackModalViewed(
    properties: PaidFeedbackModalViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PaidFeedbackModalViewed(properties), options);
  }

  /**
   * portfolio_data_refreshed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/portfolio_data_refreshed)
   *
   * Fired when the connected portfolio page completes a successful data fetch (page load, browser refresh, user-initiated refresh, or auto-refresh poll). Skipped while the tab is hidden, on errors, and when no wallet is connected.
   *
   * @param properties The event's properties (e.g. chain_count)
   * @param options Amplitude event options.
   */
  portfolioDataRefreshed(
    properties: PortfolioDataRefreshedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PortfolioDataRefreshed(properties), options);
  }

  /**
   * receive_wallet_selector_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/receive_wallet_selector_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  receiveWalletSelectorClicked(
    options?: EventOptions,
  ) {
    return this.track(new ReceiveWalletSelectorClicked(), options);
  }

  /**
   * recipient_address_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/recipient_address_updated)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. recipient_address)
   * @param options Amplitude event options.
   */
  recipientAddressUpdated(
    properties?: RecipientAddressUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RecipientAddressUpdated(properties), options);
  }

  /**
   * rwa_swap_initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/rwa_swap_initiated)
   *
   * This event represents the initiation of a real-world asset (RWA) swap by the user within the Matcha Prod application. It is triggered when the user submits a request to start exchanging an RWA token for another asset.
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  rwaSwapInitiated(
    properties: RwaSwapInitiatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RwaSwapInitiated(properties), options);
  }

  /**
   * sankey_chart_expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/sankey_chart_expanded)
   *
   * Fired when a user expands the route visualization (Sankey diagram) showing liquidity sources.
   *
   * @param properties The event's properties (e.g. ui_location)
   * @param options Amplitude event options.
   */
  sankeyChartExpanded(
    properties?: SankeyChartExpandedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SankeyChartExpanded(properties), options);
  }

  /**
   * search_abandoned
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/search_abandoned)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. [Amplitude] Session Replay ID)
   * @param options Amplitude event options.
   */
  searchAbandoned(
    properties?: SearchAbandonedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchAbandoned(properties), options);
  }

  /**
   * search_executed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/search_executed)
   *
   * Records when a user initiates a search query, capturing the search parameters.
   *
   * @param properties The event's properties (e.g. search_query)
   * @param options Amplitude event options.
   */
  searchExecuted(
    properties?: SearchExecutedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchExecuted(properties), options);
  }

  /**
   * search_focused
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/search_focused)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_type)
   * @param options Amplitude event options.
   */
  searchFocused(
    properties?: SearchFocusedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchFocused(properties), options);
  }

  /**
   * search_show_more_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/search_show_more_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. search_type)
   * @param options Amplitude event options.
   */
  searchShowMoreClicked(
    properties?: SearchShowMoreClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchShowMoreClicked(properties), options);
  }

  /**
   * search_token_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/search_token_selected)
   *
   * Records when a user selects a specific token from the search results.
   *
   * @param properties The event's properties (e.g. search_selected_address)
   * @param options Amplitude event options.
   */
  searchTokenSelected(
    properties: SearchTokenSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchTokenSelected(properties), options);
  }

  /**
   * security_audit_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/security_audit_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  securityAuditClicked(
    properties: SecurityAuditClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SecurityAuditClicked(properties), options);
  }

  /**
   * security_audit_learn_more_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/security_audit_learn_more_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  securityAuditLearnMoreClicked(
    properties: SecurityAuditLearnMoreClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SecurityAuditLearnMoreClicked(properties), options);
  }

  /**
   * sell_amount_preset_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/sell_amount_preset_selected)
   *
   * Fired when the user clicks a preset amount button ("Clear", "50%", "Max").
   *
   * @param properties The event's properties (e.g. sell_amount_preset_type)
   * @param options Amplitude event options.
   */
  sellAmountPresetSelected(
    properties: SellAmountPresetSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SellAmountPresetSelected(properties), options);
  }

  /**
   * slippage_setting_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/slippage_setting_updated)
   *
   * Fired when the user changes the slippage tolerance value using the input component available in the trade settings module. UI location should either be `settings_menu` or `trade_module. `
   *
   * @param properties The event's properties (e.g. swap_order_type)
   * @param options Amplitude event options.
   */
  slippageSettingUpdated(
    properties: SlippageSettingUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SlippageSettingUpdated(properties), options);
  }

  /**
   * suggested_token_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/suggested_token_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. chain_id)
   * @param options Amplitude event options.
   */
  suggestedTokenSelected(
    properties: SuggestedTokenSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SuggestedTokenSelected(properties), options);
  }

  /**
   * swap_initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/swap_initiated)
   *
   * User clicks swap/trade button. Captures full token pair context. Adding USD buckets for cohort analysis.
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  swapInitiated(
    properties: SwapInitiatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SwapInitiated(properties), options);
  }

  /**
   * theme_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/theme_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. theme)
   * @param options Amplitude event options.
   */
  themeToggled(
    properties: ThemeToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new ThemeToggled(properties), options);
  }

  /**
   * token_address_copied
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_address_copied)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  tokenAddressCopied(
    properties: TokenAddressCopiedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenAddressCopied(properties), options);
  }

  /**
   * token_approve_initiated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_approve_initiated)
   *
   * User initiates ERC-20 token approval transaction. Only sell token needed since approval is for spending allowance.Fired when the user clicks the "Approve Token" button, initiating the on-chain approval transaction.
   *
   * @param properties The event's properties (e.g. is_gasless_approval)
   * @param options Amplitude event options.
   */
  tokenApproveInitiated(
    properties: TokenApproveInitiatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenApproveInitiated(properties), options);
  }

  /**
   * token_approved
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_approved)
   *
   * Fired when the token approval transaction is successfully confirmed on-chain. Pair with `token_approve_initiated` to measure approval success rate and time-to-confirm.
   *
   * @param properties The event's properties (e.g. is_gasless_approval)
   * @param options Amplitude event options.
   */
  tokenApproved(
    properties: TokenApprovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenApproved(properties), options);
  }

  /**
   * token_description_expanded
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_description_expanded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  tokenDescriptionExpanded(
    properties: TokenDescriptionExpandedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenDescriptionExpanded(properties), options);
  }

  /**
   * token_group_toggled
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_group_toggled)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_symbol)
   * @param options Amplitude event options.
   */
  tokenGroupToggled(
    properties: TokenGroupToggledProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenGroupToggled(properties), options);
  }

  /**
   * token_official_link_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_official_link_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. link_type)
   * @param options Amplitude event options.
   */
  tokenOfficialLinkClicked(
    properties: TokenOfficialLinkClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenOfficialLinkClicked(properties), options);
  }

  /**
   * token_pair_flipped
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_pair_flipped)
   *
   * Fired when the user clicks the flip button to swap sell/buy tokens.
   *
   * @param properties The event's properties (e.g. buy_token_symbol)
   * @param options Amplitude event options.
   */
  tokenPairFlipped(
    properties?: TokenPairFlippedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenPairFlipped(properties), options);
  }

  /**
   * token_share_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_share_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  tokenShareClicked(
    properties: TokenShareClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenShareClicked(properties), options);
  }

  /**
   * token_switch_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/token_switch_clicked)
   *
   * Fired when the user clicks the `Switch to (token_symbol)` button on token pages.
   *
   * @param properties The event's properties (e.g. token_address)
   * @param options Amplitude event options.
   */
  tokenSwitchClicked(
    properties: TokenSwitchClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TokenSwitchClicked(properties), options);
  }

  /**
   * trade_refresh_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/trade_refresh_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  tradeRefreshClicked(
    properties: TradeRefreshClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TradeRefreshClicked(properties), options);
  }

  /**
   * trade_settings_opened
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/trade_settings_opened)
   *
   * Fired when the user clicks the gear icon to open the trade settings menu.
   *
   * @param properties The event's properties (e.g. swap_execution_type)
   * @param options Amplitude event options.
   */
  tradeSettingsOpened(
    properties: TradeSettingsOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TradeSettingsOpened(properties), options);
  }

  /**
   * trading_cta_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/trading_cta_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  tradingCtaClicked(
    options?: EventOptions,
  ) {
    return this.track(new TradingCtaClicked(), options);
  }

  /**
   * transaction_completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/transaction_completed)
   *
   * Owner: Deepanjal Gupta
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  transactionCompleted(
    properties: TransactionCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TransactionCompleted(properties), options);
  }

  /**
   * transaction_details_viewed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/transaction_details_viewed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  transactionDetailsViewed(
    options?: EventOptions,
  ) {
    return this.track(new TransactionDetailsViewed(), options);
  }

  /**
   * transaction_failed
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/transaction_failed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  transactionFailed(
    properties: TransactionFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TransactionFailed(properties), options);
  }

  /**
   * transaction_step_back
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/transaction_step_back)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. ui_location)
   * @param options Amplitude event options.
   */
  transactionStepBack(
    properties?: TransactionStepBackProperties,
    options?: EventOptions,
  ) {
    return this.track(new TransactionStepBack(properties), options);
  }

  /**
   * transaction_submitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/transaction_submitted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. buy_token_address)
   * @param options Amplitude event options.
   */
  transactionSubmitted(
    properties: TransactionSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TransactionSubmitted(properties), options);
  }

  /**
   * wallet_connect_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/wallet_connect_clicked)
   *
   * Fired when the user clicks any UI element intended to initiate a wallet connection.
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  walletConnectClicked(
    properties: WalletConnectClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletConnectClicked(properties), options);
  }

  /**
   * wallet_connection_updated
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/wallet_connection_updated)
   *
   * Fired when a wallet's connection status changes (both on successful connect and disconnect).
   *
   * @param properties The event's properties (e.g. connection_status)
   * @param options Amplitude event options.
   */
  walletConnectionUpdated(
    properties: WalletConnectionUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletConnectionUpdated(properties), options);
  }

  /**
   * wallet_disconnect_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/wallet_disconnect_clicked)
   *
   * Fired when the user clicks the UI element to disconnect their currently connected wallet.
   *
   * @param properties The event's properties (e.g. source)
   * @param options Amplitude event options.
   */
  walletDisconnectClicked(
    properties: WalletDisconnectClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WalletDisconnectClicked(properties), options);
  }

  /**
   * zora_profile_coins_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/0x/Matcha%20Prod/events/main/latest/zora_profile_coins_clicked)
   *
   * Owner: Deepanjal Gupta
   *
   * @param properties The event's properties (e.g. creator_contract_address)
   * @param options Amplitude event options.
   */
  zoraProfileCoinsClicked(
    properties?: ZoraProfileCoinsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ZoraProfileCoinsClicked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
